import { removeElementFromConditionAction } from 'editor/src/store/design/slice';
import { ConditionAddress, MediaElement } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';

import { removeElementFromReflowGroupsOperation } from './reflowGroupOperations';
import updateHiddenElementsOperation from './updateHiddenElementsOperation';

const removeElementFromConditionOperation =
  (address: ConditionAddress, optionId: string, element: MediaElement) => (dispatch: ThunkDispatch) => {
    dispatch(removeElementFromConditionAction({ address, optionId, element }));
    // The condition's own spread, not the viewer's: a design-scoped picklist
    // (showOnAllSpreads) is edited from pages that do not store it.
    dispatch(updateHiddenElementsOperation(address.spreadIndex));
    // Unlinking the option's text removes it from the condition, so drop it
    // from any reflow row to keep rows in sync with the condition's options.
    dispatch(removeElementFromReflowGroupsOperation(address.spreadIndex, element.uuid));
  };

export default removeElementFromConditionOperation;
